<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M5 13V3.5C5 2.67 5.67 2 6.5 2H14L19 7V13"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linejoin="round"
        />
        <path d="M14 2V7H19" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
        <text
            x="12"
            y="22"
            fill="currentColor"
            font-family="Arial, sans-serif"
            font-size="7"
            font-weight="700"
            text-anchor="middle"
        >
            XLS
        </text>
    </svg>
</template>
